module.exports = __webpack_public_path__ + "static/parallax-sword-7ba57a4f3776867231ec6ba0203148e5.webm";